// src/components/CartCounter.jsx
import React, { useState, useRef } from 'react';
import { useCart } from '../context/CartContext';
import { cn } from "@/lib/utils";

const CartCounter = ({ item, onUpdate, className }) => {
  const { cart, addToCart, removeFromCart, setCart } = useCart();
  const quantity = cart[item?.id]?.quantity || 0;
  const [inputValue, setInputValue] = useState(null); // null means not editing
  const inputRef = useRef(null);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputFocus = () => {
    if (inputValue === null) {
      setInputValue(quantity === 0 ? '' : String(quantity));
    }
  };

  const handleInputBlur = () => {
    let newValue = inputValue === '' || inputValue === null ? 0 : parseInt(inputValue, 10);
    if (isNaN(newValue) || newValue < 0) newValue = 0;
    
    // Only update if the value has actually changed
    if (newValue !== quantity) {
      if (newValue === 0) {
        removeFromCart(item.id, quantity); // Remove all at once
      } else {
        // Directly set the new quantity
        setCart(prevCart => ({
          ...prevCart,
          [item.id]: {
            details: item,
            quantity: newValue
          }
        }));
      }
    }
    setInputValue(null);
  };

  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleInputBlur();
      if (inputRef.current) inputRef.current.blur();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      setInputValue(null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleInputBlur();
  };

  if (!item || !item.id) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex items-center w-full max-w-[80px] flex-nowrap justify-center",
        className
      )}
      style={{ minWidth: 0 }}
    >
      <form onSubmit={handleSubmit} className="w-full">
        <input
          ref={inputRef}
          type="number"
          min="0"
          value={inputValue !== null ? inputValue : quantity === 0 ? '' : quantity}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          onKeyDown={handleInputKeyDown}
          placeholder="0"
          className={cn(
            "w-12 h-7 px-1 text-center border rounded-md text-sm bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary",
            "min-[900px]:w-12 min-[900px]:h-[30px] min-[900px]:py-[5px] min-[900px]:text-sm"
          )}
          aria-label={`Quantity of ${item.name}`}
        />
      </form>
    </div>
  );
};

export default CartCounter;